import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import { Button } from "@univdiam/ui/components/button"
import { SubCategoryDataTable } from "@univdiam/ui/customComponents/SubCategoryList/data-table"
import { categoryColumns } from "@univdiam/ui/customComponents/SubCategoryList/columns"
import { SubCategoryForm } from "@univdiam/ui/customComponents/SubCategoryList/SubCategoryForm";

import api from '@/http/api'

export default function SubCategoryPage() {
  const [data, setData] = useState([])
  const [editSubCategoryData, setEditSubCategoryData] = useState<any>(null)

  useEffect(() => {
    api.get("/api/subcategory")
    .then(res => {
      const transformed = res.data.data.map((subcategory: any) => ({
        sub_category_id: subcategory.sub_category_id.toString(),
        category_id: subcategory.category_id.toString(),
        name: subcategory.name,
        code: subcategory.code,
        status: subcategory.status === 1 ? "Enabled" : "Disabled"
      }))
      setData(transformed)
    })
    .catch(err => console.error("Failed to fetch subcategories", err))
  }, [])

  const handleDelete = async (id: string) => {
    console.log(id)
    const confirm = window.confirm("Are you sure you want to delete this subcategory?")
    if (!confirm) return
  
    try {
      const res = await api.delete(`/api/subcategory/${id}`)
      if (res.status === 200) {
        alert("SubCategory deleted successfully.")
        // Optionally refresh the table data here
      } else {
        alert("Failed to delete subcategory.")
      }
    } catch (error) {
      console.error("Delete error:", error)
      alert("Something went wrong.")
    }
  }

  const handleEdit = async (id: string) => {
    try {
      const res = await api.get(`/api/subcategory/${id}`)
      if (res.status === 200 && res.data && res.data.data) {
        setEditSubCategoryData(res.data.data)
      } else {
        alert("Failed to fetch subcategory.")
      }
    } catch (error) {
      console.error("Edit error:", error)
      alert("Something went wrong.")
    }
  }

  const navigate = useNavigate()

  const handleAddSubCategory = () => {
    navigate("/sub-category/add")
  }

  const columns = categoryColumns({ onEdit: handleEdit, onDelete: handleDelete })

  return (
    <div className="p-5">
      <div className="flex justify-between mb-4">
        <h1 className="text-xl font-semibold">Sub Category Management</h1>
        {/* <Button onClick={() => setCreateSubCategory(true)}>+ Add SubCategory</Button> */}
        <div className="flex justify-end mb-4">
        <Button onClick={handleAddSubCategory}>+ Add Sub Category</Button>
    </div>
      </div>
      <SubCategoryDataTable columns={columns} data={data} onDelete={handleDelete}/>
      {editSubCategoryData && (
        <SubCategoryForm
          initialValues={editSubCategoryData}
          isEdit
          onSubmit={async (data) => {
            try {
              const response = await api.put(`/api/subcategory/${editSubCategoryData.sub_category_id}`, data);
              if (response.status === 200) {
                alert("SubCategory updated successfully!");
                setEditSubCategoryData(null);
                
              }
            } catch (error) {
              alert("Failed to update subcategory.");
            }
          }}
        />
      )}
    </div>
  )
}
